import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  departmentLists: string[];
  designationLists: string[];
  systemStatusLists: string[];
  employeeStatusLists: string[];
  search?: string;
}

const initialState: InitialState = {
  departmentLists: [],
  designationLists: [],
  systemStatusLists: [],
  employeeStatusLists: [],
  search: "",
};

const employeeListSlice = createSlice({
  name: "employeeList",
  initialState,
  reducers: {
    setDepartmentLists: (state, action: PayloadAction<string[]>) => {
      state.departmentLists = action.payload;
    },
    setDesignationLists: (state, action: PayloadAction<string[]>) => {
      state.designationLists = action.payload;
    },
    setSystemStatusLists: (state, action: PayloadAction<string[]>) => {
      state.systemStatusLists = action.payload;
    },
    setEmployeeStatusLists: (state, action: PayloadAction<string[]>) => {
      state.employeeStatusLists = action.payload;
    },
    setEmployeeSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
  },
});

export const {
  setDepartmentLists,
  setDesignationLists,
  setSystemStatusLists,
  setEmployeeStatusLists,
  setEmployeeSearch,
} = employeeListSlice.actions;
export default employeeListSlice.reducer;
